import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Paper, Stack, Box, Typography, Skeleton } from "@mui/material";

/**
 * One KPI tile: a pastel badge, a label, and the number.
 *
 * The old version painted the whole card in a saturated gradient, which made six cards compete with
 * each other and left white-on-colour numbers as the least readable text on the page. Here the
 * colour is carried by the 48px badge only, so the value reads at full contrast.
 */
export default function TutorStatCard({ label, value, icon, bg, fg, to, loading = false }) {
  if (loading) {
    return <Skeleton variant="rounded" height={80} sx={{ borderRadius: 3 }} />;
  }

  return (
    <Paper
      {...(to ? { component: RouterLink, to } : {})}
      sx={{
        p: 2,
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        border: "1px solid #eef0f4",
        textDecoration: "none",
        display: "block",
        cursor: to ? "pointer" : "default",
        transition: "box-shadow 0.15s ease",
        "&:hover": to ? { boxShadow: "0 6px 20px rgba(0,0,0,0.08)" } : {},
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "50%",
            bgcolor: bg,
            color: fg,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="caption" sx={{ color: "#374151", fontWeight: 700 }} noWrap>
            {label}
          </Typography>
          {/* Deliberately not variant="h5": theme.js caps h5 at 1.125rem, which is barely larger
              than the label sitting above it. */}
          <Typography sx={{ fontSize: 24, fontWeight: 800, lineHeight: 1.1, color: "#111827" }}>
            {typeof value === "number" ? value.toLocaleString() : value}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
}
